import { SelectedEquipmentCard } from '@/components/SelectedEquipmentCard'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { SearchableSelect, type SearchableSelectOption } from '@/components/ui/searchable-select'
import { Textarea } from '@/components/ui/textarea'
import type { ItemDetail } from '@/features/items/types/item'
import { type Dispatch, type SetStateAction } from 'react'
import { useTranslation } from 'react-i18next'
import { CurrentUserNote } from '../ScanItemShared'

type RequestForm = { quantityRequested: string; targetDepartmentId: string; reason: string }

export function RequestSection({
  item,
  form,
  setForm,
  departmentOptions,
  currentUserName,
  isSubmitting,
  onSubmit,
}: {
  item: ItemDetail
  form: RequestForm
  setForm: Dispatch<SetStateAction<RequestForm>>
  departmentOptions: SearchableSelectOption[]
  currentUserName?: string
  isSubmitting: boolean
  onSubmit: () => void
}) {
  const { t } = useTranslation()

  return (
    <div className="flex flex-col gap-3" data-testid="request-form">
      <SelectedEquipmentCard
        name={item.product?.name}
        brand={item.product?.brand}
        model={item.product?.model}
        categoryName={item.product?.categoryName}
      />
      {/* <div className="flex flex-col gap-1.5">
        <Label className="text-xs">{t('scans.transfer.availableToRequest', {count: item.product?.availableAtOwner, total:item.product?.itemSummary.total})} </Label>
      </div> */}
      <div className="flex flex-col gap-1.5">
        <Label className="text-xs">{t('scans.field.targetDepartment')} *</Label>
        <SearchableSelect
          value={form.targetDepartmentId}
          onValueChange={targetDepartmentId => setForm({ ...form, targetDepartmentId })}
          options={departmentOptions}
          placeholder={t('scans.placeholder.selectDepartment')}
          searchPlaceholder={t('scans.placeholder.searchDepartment')}
          emptyText={t('scans.placeholder.noDepartment')}
          triggerClassName="bg-secondary/50 text-xs"
          testId="request-department-select"
        />
      </div>
      <div className="flex flex-col gap-1.5">
        <Label className="text-xs">{t('requests.quantity')} *</Label>
        <Input
          data-testid="request-quantity-input"
          type="number"
          min="1"
          value={form.quantityRequested}
          onChange={e => setForm({ ...form, quantityRequested: e.target.value })}
          className="h-9 bg-secondary/50 text-xs"
        />
      </div>
      <div className="flex flex-col gap-1.5">
        <Label className="text-xs">{t('scans.field.reason')} *</Label>
        <Textarea
          data-testid="request-reason"
          value={form.reason}
          onChange={e => setForm({ ...form, reason: e.target.value })}
          className="bg-secondary/50 text-xs"
          rows={3}
          placeholder={t('scans.placeholder.requestReason')}
        />
      </div>
      <CurrentUserNote label={t('scans.request.requester')} name={currentUserName} />
      <Button
        data-testid="request-submit-button"
        onClick={onSubmit}
        className="text-xs"
        disabled={!form.quantityRequested || !form.targetDepartmentId || !form.reason || isSubmitting}
      >
        {isSubmitting ? t('scans.request.submitting') : t('scans.request.submit')}
      </Button>
    </div>
  )
}
